import Pagination from "rc-pagination";
import React from "react";
const CustomPagination = ({
  total,
  currentPage,
  pageSize = 10,
  onPageChange,
  shape = "square"
}: any) => {
  const PrevNextArrow = (current: any, type: any, originalElement: any) => {
    if (type === "prev") {
      return (
        <button>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            className="custom-prev-icon"
          >
            <path
              d="M15.4099 16.59L10.8299 12L15.4099 7.41L13.9999 6L7.99991 12L13.9999 18L15.4099 16.59Z"
              fill="#808080"
            />
          </svg>
        </button>
      );
    }
    if (type === "next") {
      return (
        <button>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            className="custom-next-icon"
          >
            <path
              d="M8.58984 7.41L13.1698 12L8.58984 16.59L9.99984 18L15.9998 12L9.99984 6L8.58984 7.41Z"
              fill="#808080"
            />
          </svg>
        </button>
      );
    }
    return originalElement;
  };
  return (
    <Pagination
      showTitle={false}
      className={`pagination-data ${shape == "circle" ? "shape-circle" : ""}`}
      onChange={(page: any, pageSize: any) => onPageChange(page, pageSize)}
      total={total}
      pageSize={pageSize}
      current={currentPage}
      itemRender={PrevNextArrow}
      showLessItems={true}
    />
  );
};
export default CustomPagination;